import React, { Fragment } from 'react';
import './Reports.css';
import Image from '../../assets/Services/reports.svg';
import Fade from 'react-reveal/Fade';
import { Dimensions } from "../../Helper/sitedimension";

const reports = () => {
    const { width } = Dimensions.useWindowDimensions();
    return (
        <div className="reports">
            {width > 500 ?
                <Fragment>
                    <div className="container-fluid bg-1">
                        <div className="main">
                            <Fade top delay={300}>
                                <span className="content"> Reports  </span>
                                <span className="content1"> & </span>
                                <span className="content2">Analysis</span>
                            </Fade>
                        </div>
                        <h6 className="content3"><Fade delay={400}>Two reports are created for every scan we perform.</Fade></h6>
                        <div className="report-type1">
                            <h5 className="name"><Fade delay={600}>Technical Report</Fade></h5>
                            <h5 className="content">
                                <Fade delay={800}>
                                Contains details of every potential risks and technical impact which can help in 
                                generating actionable recommendations. Using this report, a solutions manager can identify the roadblocks in the system.
                        </Fade>
                            </h5>
                        </div>
                        <div className="report-type2">
                            <h5 className="name"><Fade delay={600}>Manager's Report</Fade></h5>
                            <h5 className="content">
                                <Fade delay={800}>
                                Contains high level details of related to the potential cyber threats along with the financial impact that might be caused at the later stages. 
                                It also prioritizes the risks according to their severity. 
                        </Fade>
                            </h5>
                        </div>
                        <Fade delay={1200}>
                            <button className="report-button">
                                <span className="btn-content">Download Sample Report &nbsp;&nbsp;</span>
                            </button>
                        </Fade>
                        <Fade delay={1000}>
                            <img className="main-image" src={Image} alt="report" />
                        </Fade>
                    </div>
                </Fragment> :
                <Fragment>
                    <div className="mainrep">
                        <Fade top delay={300}>
                            <span className="contentrep"> Reports  </span>
                            <span className="content1rep"> & </span>
                            <span className="content2rep">Analysis</span>
                        </Fade>
                    </div>
                    <h6 className="content3rep"><Fade delay={400}>We make 2 reports for every scan we perform.</Fade></h6>
                    <div className="report-type1rep">
                        <h5 className="namerep"><Fade delay={600}>Technical Report</Fade></h5>
                        <h5 className="contentrep">
                            <Fade delay={800}>
                            Contains details of every potential risks and technical impact which can help in 
                                generating actionable recommendations. Using this report, a solutions manager can identify the roadblocks in the system.
                        </Fade>
                        </h5>
                    </div>
                    <div className="report-type2rep">
                        <h5 className="namerep"><Fade delay={600}>Manager's Report</Fade></h5>
                        <h5 className="contentrep">
                            <Fade delay={800}>
                            Contains high level details of related to the potential cyber threats along with the financial impact that might be caused at the later stages. 
                                It also prioritizes the risks according to their severity. 
                      
                        </Fade>
                        </h5>
                    </div>
                    <Fade delay={1200}>
                        <button className="report-buttonrep">
                            <span className="btn-contentrep">Download Sample Report &nbsp;&nbsp;</span>
                        </button>
                    </Fade>
                </Fragment>
            }
        </div>
    )
}

export default reports;